// Set curato di icone (lucide) + gradienti per il "Pulsante personalizzato"
// del Welcome Book. Condiviso tra editor (admin) e guest app.
import {
  MapPin, Utensils, Wine, Coffee, Waves, ShoppingBag, Car, TrainFront,
  Pill, Dumbbell, Wifi, CalendarDays, Gift, Heart, Star, Info, Phone,
  Camera, Mountain, Bike, Bus, Ship, Plane, Key, Bed, Music, Ticket,
  Sparkles, Sun, Moon, TreePine, GlassWater, Shirt, Scissors, Dog,
  Baby, Flame, Leaf, Compass,
} from "lucide-react";

export const CUSTOM_ICONS = {
  map: MapPin, food: Utensils, wine: Wine, coffee: Coffee, beach: Waves,
  shopping: ShoppingBag, parking: Car, train: TrainFront, pharmacy: Pill,
  gym: Dumbbell, wifi: Wifi, event: CalendarDays, gift: Gift, heart: Heart,
  star: Star, info: Info, phone: Phone, camera: Camera, mountain: Mountain,
  bike: Bike, bus: Bus, boat: Ship, plane: Plane, key: Key, bed: Bed,
  music: Music, ticket: Ticket, sparkles: Sparkles, sun: Sun, moon: Moon,
  tree: TreePine, drink: GlassWater, laundry: Shirt, beauty: Scissors,
  dog: Dog, baby: Baby, fire: Flame, nature: Leaf, explore: Compass,
};

export const CUSTOM_ICON_LIST = Object.keys(CUSTOM_ICONS);

export const CUSTOM_GRADIENTS = [
  "linear-gradient(135deg,#6366F1 0%,#4F46E5 55%,#3730A3 100%)",
  "linear-gradient(135deg,#FB7185 0%,#F43F5E 55%,#BE123C 100%)",
  "linear-gradient(135deg,#A78BFA 0%,#8B5CF6 55%,#5B21B6 100%)",
  "linear-gradient(135deg,#34D399 0%,#10B981 55%,#047857 100%)",
  "linear-gradient(135deg,#FBBF24 0%,#F59E0B 55%,#B45309 100%)",
  "linear-gradient(135deg,#22D3EE 0%,#0891B2 55%,#155E75 100%)",
  "linear-gradient(135deg,#FF6B60 0%,#FF3B30 55%,#D42A20 100%)",
  "linear-gradient(135deg,#E879F9 0%,#C026D3 55%,#701A75 100%)",
  "linear-gradient(135deg,#2DD4BF 0%,#0D9488 55%,#115E59 100%)",
  "linear-gradient(135deg,#475569 0%,#1F2937 55%,#0F172A 100%)",
];
